import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";
import { Study } from "./StudyApi";

export class DemoStudy {
  constructor(public code: string, public number: number, public label: string, public study: Study) {}
}

export default class DemoStudyApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new DemoStudyApi(axios);
  }

  results = new Map<string, Array<DemoStudy>>();

  findStudies(code: string): Promise<Array<DemoStudy>> {
    const query = code.trim() || "demo";

    if (this.results.has(query)) {
      return Promise.resolve(this.results.get(query));
    }

    return this.client
      .get("/demo-studies", {
        params: {
          code: query,
        },
      })
      .then((resp) => {
        this.results.set(query, resp.data);
        return resp.data;
      });
  }
}
